<script setup lang="ts">
// generated from file:///input/au_src/shop/pages/legal/revocation.ts
/*─────────────────────────────────────┐
│   props                              │
└─────────────────────────────────────*/
/*─────────────────────────────────────┐
│   composables                        │
└─────────────────────────────────────*/
/*─────────────────────────────────────┐
│   refs                               │
└─────────────────────────────────────*/
/*─────────────────────────────────────┐
│   setup                              │
└─────────────────────────────────────*/
</script>

<!-- generated from file:///input/au_src/shop/pages/legal/revocation.html -->
<template>
    <div class="container legal-text">
        <div class="breadcrumb">
            <RouterLink class="breadcrumb-item" :to="{ name: 'home' }">Home</RouterLink>
            <div class="breadcrumb-item">Widerrufsbelehrung</div>
        </div>

        <h1 class="my-5">Widerrufsbelehrung</h1>

        <div class="font-weight-bold text-center">Widerrufsbelehrung</div>

        <b>Widerrufsrecht</b>

        <p>
            Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die
            Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht
            der Beförderer ist, die letzte Ware in Besitz genommen haben bzw. hat. Um Ihr Widerrufsrecht auszuüben,
            müssen Sie uns
        </p>

        <p>
            apotheke am inselpark
            <br />
            Apotheker Björn Schrage e.K.
            <br />
            Neuenfelder Straße 31
            <br />
            21109 Hamburg
            <br />
            Telefon 040 30238699-0 (Mo. bis Fr. 8:00 bis 18:30 Uhr)
            <br />
            E-Mail: info@apotheke-inselpark.de
        </p>

        <p>
            mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren
            Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte
            Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist. Sie können Ihr Widerrufsrecht auch
            online unter
            <RouterLink :to="{ name: 'revoke-order' }">Vertrag widerrufen</RouterLink>
            ausüben. Wenn Sie diese Online-Funktion nutzen, übermitteln wir Ihnen auf einem dauerhaften Datenträger
            (z.B. durch eine E-Mail) unverzüglich eine Eingangsbestätigung mit Informationen zum Inhalt der
            Widerrufserklärung sowie dem Datum und der Uhrzeit ihres Eingangs. Zur Wahrung der Widerrufsfrist reicht es
            aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
        </p>

        <b>Folgen des Widerrufs</b>

        <p>
            Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben,
            einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie
            eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben),
            unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
            Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe
            Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde
            ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte
            berechnet. Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie
            den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere
            Zeitpunkt ist. Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem
            Tag, an dem Sie uns über den Widerruf dieses Vertrags unterrichten, an uns:
        </p>

        <p>
            apotheke am inselpark
            <br />
            Apotheker Björn Schrage e.K.
            <br />
            Neuenfelder Straße 31
            <br />
            21109 Hamburg
        </p>

        <p>
            zurückzusenden oder zu übergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von
            vierzehn Tagen absenden. Sie tragen die unmittelbaren Kosten der Rücksendung der Waren. Sie müssen für einen
            etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der
            Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen
            ist.
        </p>

        <div class="legal-form">
            <div class="font-weight-bold text-center">Muster-Widerrufsformular</div>

            <p>
                (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es
                zurück.)
            </p>

            <p>An</p>

            <p>
                apotheke am inselpark
                <br />
                Apotheker Björn Schrage e.K.
                <br />
                Neuenfelder Straße 31
                <br />
                21109 Hamburg
                <br />
                Telefax 040 30238699-22
                <br />
                Mail info@apotheke-inselpark.de
            </p>

            <p>
                Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden
                Waren (*)/die Erbringung der folgenden Dienstleistung (*)
            </p>

            <div class="fake-input"></div>
            <p>Bestellt am (*)</p>

            <div class="fake-input"></div>
            <p>erhalten am (*)</p>

            <div class="fake-input"></div>
            <p>Name des/der Verbraucher(s)</p>

            <div class="fake-input"></div>
            <p>Anschrift des/der Verbraucher(s)</p>
            <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</p>

            <div class="fake-input"></div>
            <p>Datum</p>
            <p>(*) Unzutreffendes streichen</p>
        </div>
    </div>
</template>
